import React from 'react';
import componentStyles from './banner.module.css'; // Import the CSS file for styling

// Banner component to display the site name
const Banner = () => {
    const handleRedirect = () => {
        // Redirect to the appropriate page based on authentication status
        window.location.href = '/'; // Redirect to home if not logged in
        // if (AppState.isUserAuthenticated()) {
        //     window.location.href = '/user-home'; // Redirect to user home if logged in
        // } else {
        //     window.location.href = '/home'; // Redirect to home if not logged in
        // }
    };

    return (
        <div className={componentStyles.banner}>
            <button type="button" className={componentStyles.brand} onClick={handleRedirect} aria-label="Return to StatSpyder home">
                <img
                    className={componentStyles.brandMark}
                    src={`${process.env.PUBLIC_URL}/logo192.png`}
                    alt=""
                    width="40"
                    height="40"
                />
                <span className={componentStyles.brandName}>STATSPYDER</span>
                <span className={componentStyles.terminalLabel}>SPORTS INTELLIGENCE TERMINAL</span>
            </button>
            <div className={componentStyles.systemStatus}>
                <span className={componentStyles.statusDot}></span>
                <span>MARKETS LIVE</span>
            </div>
            {/* TODO: we want to display different banners based on mobile or desktop */}
            {/* <h1 onClick={handleRedirect} style={{ cursor: 'pointer' }}>GTerminal by Statspyder</h1> */}
        </div>
    );
};

export default Banner;
